import React, { useMemo, useState } from "react";
import { Card, CardHeader, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function TransactionsHistory({ transactions = [], title = "Wallet Transactions", rowsPerPage = 5 }) {
  const [page, setPage] = useState(1);

  const { totalPages, visible } = useMemo(() => {
    const total = Math.max(1, Math.ceil((transactions?.length || 0) / rowsPerPage));
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return { totalPages: total, visible: (transactions || []).slice(start, end) };
  }, [transactions, page, rowsPerPage]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) setPage(newPage);
  };

  return (
    <Card>
      <CardHeader title={title} />
      <CardContent>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Description</TableCell>
                <TableCell align="right">Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {visible.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">No transactions found</TableCell>
                </TableRow>
              ) : (
                visible.map((t) => (
                  <TableRow key={t.id} hover>
                    <TableCell>{t.date ? new Date(t.date).toLocaleString() : ""}</TableCell>
                    <TableCell style={{ textTransform: 'capitalize' }}>{t.type}</TableCell>
                    <TableCell>{t.desc}</TableCell>
                    <TableCell align="right" style={{ color: t.type === 'credit' ? '#2e7d32' : '#c62828' }}>
                      {t.type === 'credit' ? '+' : '-'}${Number(t.amount || 0).toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <MDBox mt={2} display="flex" justifyContent="center" alignItems="center">
          <Button onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
            Previous
          </Button>
          <MDTypography mx={2}>Page {page} of {totalPages}</MDTypography>
          <Button onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>
            Next
          </Button>
        </MDBox>
      </CardContent>
    </Card>
  );
}

export default TransactionsHistory;

